import { cva as e } from "class-variance-authority";
// src/design/forms/radio/style.ts
var t = e("flex flex-col gap-1", {
	variants: { orientation: {
		vertical: "flex-col",
		horizontal: "flex-row flex-wrap"
	} },
	defaultVariants: { orientation: "vertical" }
}), n = e("text-sm font-medium text-foreground mb-1.5 data-[disabled]:opacity-90 data-[disabled]:cursor-not-allowed"), r = e("absolute inset-0 rounded-md bg-secondary border-2 border-primary transition-all duration-normal opacity-0", { variants: { orientation: {
	vertical: "",
	horizontal: ""
} } }), i = e("group relative inline-flex items-center gap-2 cursor-pointer data-[disabled]:cursor-not-allowed data-[disabled]:opacity-90", {
	variants: { size: {
		sm: "gap-1.5",
		md: "gap-1.5",
		lg: "gap-2"
	} },
	defaultVariants: { size: "md" }
}), a = e([
	"relative flex items-center justify-center rounded-full transition-colors duration-normal",
	"before:absolute before:inset-0 before:rounded-full before:transition-all before:duration-normal",
	"group-hover:before:bg-muted",
	"disabled:before:bg-transparent"
], {
	variants: { size: {
		sm: "p-0.5 before:-m-0.5",
		md: "p-1 before:-m-0.5",
		lg: "p-1.5 before:-m-0.5"
	} },
	defaultVariants: { size: "md" }
}), o = e([
	"relative shrink-0 rounded-full border-2 border-input-border transition-all duration-normal",
	"group-data-[disabled]:pointer-events-none group-data-[disabled]:opacity-90",
	"data-[state=checked]:border-primary data-[state=checked]:bg-primary",
	"data-[focus-visible]:border-ring data-[focus-visible]:ring-3 data-[focus-visible]:ring-ring/50"
], {
	variants: {
		size: {
			sm: "h-4 w-4",
			md: "h-5 w-5",
			lg: "h-6 w-6"
		},
		variant: {
			default: "bg-input-back",
			subtle: "border-border bg-muted",
			ghost: "border-border"
		},
		checked: {
			true: "",
			false: ""
		}
	},
	defaultVariants: {
		size: "md",
		variant: "default",
		checked: !1
	}
}), s = e("absolute inset-0 flex items-center justify-center", {
	variants: { size: {
		sm: "",
		md: "",
		lg: ""
	} },
	defaultVariants: { size: "md" }
}), c = e("flex", {
	variants: { orientation: {
		horizontal: "gap-2",
		vertical: "flex-col"
	} },
	defaultVariants: { orientation: "horizontal" }
}), l = e("rounded-full bg-back transition-transform duration-normal scale-0", {
	variants: {
		size: {
			sm: "h-1.5 w-1.5",
			md: "h-2 w-2",
			lg: "h-2.5 w-2.5"
		},
		checked: {
			true: "scale-100",
			false: ""
		}
	},
	defaultVariants: {
		size: "md",
		checked: !1
	}
}), u = e("select-none text-sm font-normal text-foreground group-data-[disabled]:opacity-90"), d = e("text-sm font-medium text-destructive"), f = e("text-xs text-muted-foreground"), p = e("sr-only"), m = (e) => ({
	root: () => t({ orientation: e?.orientation }),
	label: () => n(),
	defaultWrapper: () => c({ orientation: e?.orientation }),
	indicator: () => r({ orientation: e?.orientation }),
	item: () => i({ size: e?.size }),
	controlWrapper: () => a({ size: e?.size }),
	control: (t) => o({
		size: e?.size,
		variant: e?.variant,
		checked: !!t
	}),
	controlIndicator: () => s({ size: e?.size }),
	controlIndicatorDot: (t) => l({
		size: e?.size,
		checked: !!t
	}),
	itemText: () => u(),
	itemHiddenInput: () => p(),
	errorText: () => d(),
	helperText: () => f()
});
export { l as controlIndicatorDotStyles, s as controlIndicatorStyles, o as controlStyles, a as controlWrapperStyles, c as defaultParentWrapperStyles, d as errorTextStyles, m as getStyles, f as helperTextStyles, p as hiddenInputStyles, r as indicatorStyles, i as itemStyles, u as itemTextStyles, n as labelStyles, t as rootStyles };

//# sourceMappingURL=style.js.map